
export class MonthWiseExcelDataModel {
    itemCode: string;
    itemName: string;
    prodPlanTypeName: string;
    oldOrderQtyPcs1: number;
    oldOrderQtyPcs2: number;
    oldOrderQtyPcs3: number;
    oldOrderQtyPcs4: number;
    oldOrderQtyPcs5: number;
    oldOrderQtyPcs6: number;
    oldOrderQtyPcs7: number;
    oldOrderQtyPcs8: number;
    oldOrderQtyPcs9: number;
    oldOrderQtyPcs10: number;
    oldOrderQtyPcs11: number;
    oldOrderQtyPcs12: number;
    constructor(itemCode: string, itemName: string, prodPlanTypeName: string, oldOrderQtyPcs1: number, oldOrderQtyPcs2: number, oldOrderQtyPcs3: number, oldOrderQtyPcs4: number, oldOrderQtyPcs5: number, oldOrderQtyPcs6: number, oldOrderQtyPcs7: number, oldOrderQtyPcs8: number, oldOrderQtyPcs9: number, oldOrderQtyPcs10: number, oldOrderQtyPcs11: number, oldOrderQtyPcs12: number) {
        this.itemCode = itemCode
        this.itemName = itemName
        this.prodPlanTypeName = prodPlanTypeName;
        this.oldOrderQtyPcs1 = oldOrderQtyPcs1;
        this.oldOrderQtyPcs2 = oldOrderQtyPcs2;
        this.oldOrderQtyPcs3 = oldOrderQtyPcs3;
        this.oldOrderQtyPcs4 = oldOrderQtyPcs4;
        this.oldOrderQtyPcs5 = oldOrderQtyPcs5;
        this.oldOrderQtyPcs6 = oldOrderQtyPcs6;
        this.oldOrderQtyPcs7 = oldOrderQtyPcs7;
        this.oldOrderQtyPcs8 = oldOrderQtyPcs8;
        this.oldOrderQtyPcs9 = oldOrderQtyPcs9;
        this.oldOrderQtyPcs10 = oldOrderQtyPcs10;
        this.oldOrderQtyPcs11 = oldOrderQtyPcs11;
        this.oldOrderQtyPcs12 = oldOrderQtyPcs12;
    };
}